"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderCardsCommand = void 0;
class RenderCardsCommand extends CustomEvent {
    constructor(identifier, listType, placeholderElement) {
        const detail = {
            identifier,
            listType,
            placeholderElement
        };
        super('', { detail });
    }
}
exports.RenderCardsCommand = RenderCardsCommand;
